/*
 * XxValueBadge Theme Configuration
 * Centralized styling for XxValueBadgeDisplay component
 * Used in both ProductTile and ProductView
 */
const sharedStyles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        fontStyle: 'italic',
        fontWeight: '400',
        textAlign: 'center',
        textTransform: 'none',
        color: 'black.300'
    },
    amountWrapper: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '3px'
    },
    currencySymbol: {
        fontFamily: 'cormorant',
        fontSize: {base: '24px', lg: '32px'},
        lineHeight: {base: '16px', lg: '24px'},
        fontStyle: 'italic',
        letterSpacing: {base: '0.12px', lg: '0.16px'},
        fontWeight: '400'
    },
    currencySymbolPDP: {
        fontFamily: 'cormorant',
        fontSize: '32px',
        lineHeight: '24px',
        fontStyle: 'italic',
        letterSpacing: '0.16px',
        fontWeight: '400'
    },
    amount: {
        fontFamily: 'caslon',
        fontSize: {base: '24px', lg: '36px'},
        fontStyle: 'italic',
        lineHeight: {base: '24px', lg: '32px'},
        fontWeight: '400',
        letterSpacing: {base: '0.12px', lg: '0.18px'}
    },
    amountPDP: {
        fontFamily: 'caslon',
        fontSize: '36px',
        fontStyle: 'italic',
        letterSpacing: '0.18px',
        lineHeight: '32px',
        fontWeight: '400'
    },
    badgeLabel: {
        fontSize: {base: '14px', lg: '18px'},
        fontFamily: 'caslon',
        lineHeight: {base: '16px', lg: '20px'},
        fontWeight: '400',
        letterSpacing: {base: '0.07px', lg: '0.09px'}
    },
    badgeLabelPDP: {
        fontSize: '18px',
        fontFamily: 'caslon',
        lineHeight: '20px',
        fontWeight: '400',
        letterSpacing: '0.9px'
    }
}

export default {
    baseStyle: sharedStyles,
    variants: {
        pdp: {
            currencySymbol: {
                ...sharedStyles.currencySymbolPDP
            },
            amount: {
                ...sharedStyles.amountPDP
            },
            badgeLabel: {
                ...sharedStyles.badgeLabelPDP
            }
        }
    },
    defaultProps: {
        variant: 'plp'
    }
}
